import { createAction } from '@reduxjs/toolkit';
import {
  ADD_EVENT,
  DELETE_EVENT,
  DELETE_EVENT_IMAGE,
  EDIT_EVENT,
  GET_EVENT,
  GET_EVENTS,
  NOTIFY_EVENT,
  SYNC_EVENT_IMAGES,
  UPLOAD_EVENT_IMAGE,
  UPLOAD_EVENT_IMAGES_BATCH
} from '../constants';

export const getEvents = createAction(GET_EVENTS);
export const getEvent = createAction(GET_EVENT);
export const addEvent = createAction(ADD_EVENT);
export const editEvent = createAction(EDIT_EVENT);
export const deleteEvent = createAction(DELETE_EVENT);
export const notifyEvent = createAction(NOTIFY_EVENT);
export const uploadEventImage = createAction(UPLOAD_EVENT_IMAGE);
export const deleteEventImage = createAction(DELETE_EVENT_IMAGE);
export const uploadEventImagesBatch = createAction(UPLOAD_EVENT_IMAGES_BATCH);
export const syncEventImages = createAction(SYNC_EVENT_IMAGES);

export default {
  getEvents,
  getEvent,
  addEvent,
  editEvent,
  deleteEvent,
  notifyEvent,
  uploadEventImage,
  deleteEventImage,
  uploadEventImagesBatch,
  syncEventImages
};
